






































































import { defineComponent, reactive, toRefs, onMounted, ref, onBeforeUnmount } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { StudentFile } from "../../modules/teacher/StudentFileUploadDetail"

export interface Data {
  student_file_upload_id: string
  studentFiles: StudentFile[]
  title: string
  fields: any[]
  errors: string[]
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalFileUploadRef = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      student_file_upload_id: null,
      studentFiles: new Array<StudentFile>(),
      title: null,
      fields: [
        {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "room_name", label: "組", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "student_no", label: "出席番号", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "student_no_character", label: "学籍番号", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "name", label: "氏名", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "is_publish", label: "公開", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "100px"}},
        {key: "download", label: "ダウンロード", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "150px"}},
        {key: "delete", label: "削除", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "100px"}},
      ],
      errors: [],
    });

    const allPublishSelectChanged = (isChecked: boolean) => {
      state.studentFiles.forEach(x => x.is_publish = isChecked);
    }

    const allDownloadSelectChanged = (isChecked: boolean) => {
      state.studentFiles.forEach(x => x.is_download_checked = isChecked);
    }

    const allDeleteSelectChanged = (isChecked: boolean) => {
      state.studentFiles.forEach(x => x.is_delete_checked = isChecked);
    }

    const updatePublish = async () => {

      state.errors = [];

      const studentFiles = state.studentFiles.filter(x => x.is_publish != x.is_publish_cache);

      if(studentFiles.length == 0){
        alert("変更された行がありません。");
        return;
      }

      if (!window.confirm('公開状態を更新します。よろしいですか？')) {
        return;
      }

      const ids = studentFiles.map(x => x.id);
      const is_publishes = studentFiles.map(x => x.is_publish);

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/student_file_upload_detail/update_publish`, {student_file_upload_id: state.student_file_upload_id, ids: ids, is_publishes: is_publishes}).then(response => {
        alert("処理が完了しました。");
        state.studentFiles.forEach(x => x.is_publish_cache = x.is_publish);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    const deletePdf = async () => {

      state.errors = [];

      const ids = state.studentFiles.filter(x => x.is_delete_checked).map(x => x.id);

      if(ids.length == 0){
        alert("削除対象を選択してください。");
        return;
      }

      if (!window.confirm('選択している生徒のファイルを削除します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/student_file_upload_detail/destroy`, {student_file_upload_id: state.student_file_upload_id, ids: ids}).then(response => {
        alert("処理が完了しました。");
        if(response.data.student_files_count > 0){
          window.location.reload();
        }else{
          // PDFが0件になった場合は一覧に戻る
          window.history.back();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    const downloadPdf = async () => {

      state.errors = [];

      const student_no_characters = state.studentFiles.filter(x => x.is_download_checked).map(x => x.student_no_character);

      if(student_no_characters.length == 0){
        alert("ダウンロード対象を選択してください。");
        return;
      }

      if (!window.confirm('選択している生徒のファイルをダウンロードします。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/student_file_upload_detail/download`, {student_file_upload_id: state.student_file_upload_id, student_no_characters: student_no_characters}, {responseType: 'blob'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.title}.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * アップロード
     ************************************************************/

    const upload = async (file: any) => {
      state.errors = [];

      if(!state.title){
        alert("表題を入力してください。");
        return;
      }

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', file[0]);
      fd.append('student_file_upload_id', state.student_file_upload_id);

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/student_file_upload_detail/upload`, fd).then(async response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      modalFileUploadRef.value.hide();

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.student_file_upload_id = context.root.$route.params.student_file_upload_id;
      await http.get(`/api/teacher/student_file_upload_detail?student_file_upload_id=${state.student_file_upload_id}`).then(response => {
        state.studentFiles = response.data.student_files.map((x: any) => new StudentFile(x));
        state.title = response.data.title;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`データの取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`データの取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      modalFileUploadRef,
      allPublishSelectChanged,
      allDownloadSelectChanged,
      allDeleteSelectChanged,
      updatePublish,
      deletePdf,
      downloadPdf,
      upload,
    };
  }
});

